import React, { useEffect, useMemo, useRef, useState } from 'react';

import { create } from './player';
import { PlayerOverlay } from './playerOverlay';

interface RegionVideoWixProps {
  url: string;
  previewImageAltText?: string;
  experiments: Record<string, 'true' | 'false'>;
}

export function RegionVideoWix(props: RegionVideoWixProps) {
  const { url, previewImageAltText, experiments } = props;
  const ref = useRef(null);

  const [showOverlay, setShowOverlay] = useState(true);

  // eslint-disable-next-line dot-notation
  const accessiblePlayerEnabled =
    experiments['specs.so.public.makeVideoPlayerAccessible'] === 'true';

  const player = useMemo(() => {
    if (url) {
      return accessiblePlayerEnabled
        ? create(url, {
            fillAllSpace: true,
          })
        : window.WixMGPlayer.create(url, {
            fillAllSpace: true,
            overlay: {
              poster: getPreviewThumbnail(url),
            },
          });
    }
  }, [accessiblePlayerEnabled, url]);

  useEffect(() => {
    if (player && ref.current) {
      player.attachToElement(ref.current);
      return () => {
        player.player.destroy();
      };
    }
  }, [player]);

  return (
    <div
      style={{
        paddingBottom: '56.25%',
        position: 'relative',
        overflow: 'visible',
      }}
    >
      {accessiblePlayerEnabled && showOverlay && (
        <PlayerOverlay
          previewImageUrl={getPreviewThumbnail(url)}
          previewImageAltText={previewImageAltText}
          onPlay={() => {
            setShowOverlay(false);
            player?.play!();
          }}
        />
      )}
      <div
        ref={ref}
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          left: 0,
          top: 0,
          display: accessiblePlayerEnabled && showOverlay ? 'none' : 'block',
        }}
      />
    </div>
  );
}

function getPreviewThumbnail(url: string) {
  return window.VideoGallerySDK.getVideoImage(url, {
    width: 1600,
    height: 900,
    previewIndex: 2,
  });
}
